import React, { useEffect, useState } from "react";
import DesktopSideBar from "../../components/DesktopSideBar";
import MobileNavbar from "../../components/MobileNavbar";
import "./style.css";
import MeetCard from "../../components/MeetCard";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress } from "@mui/material";

import { db, collection, getDocs } from "./../../config/firebase";

const Index = () => {
  const [loading, setLoading] = useState(false);

  //   filtering names (A-z) and by start dates
  const filterByNameAndDate = (array) => {
    array.sort((a, b) => {
      const nameA = a.name.toUpperCase(); // convert name to uppercase to ignore case sensitivity
      const nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1; // nameA comes before nameB
      }
      if (nameA > nameB) {
        return 1;
      }

      array.sort((a, b) => a.startDate.seconds - b.date.seconds);
      return array;
    });
  };

  const matches = useMediaQuery("(max-width:600px)");
  const [getMeetsAgain, setGetMeetsAgain] = useState(false);
  const [typeToFilter, setTypeToFilter] = useState("All");
  const meetTypes = ["All", "ACRO", "T&T", "MAG", "WAG"];
  const [meetsCollection, setMeetsCollection] = useState([]);


  // getting all meets and setting in state meetsCollection
  useEffect(() => {
    const fetchMeetsData = async () => {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, "managedMeets"));
      if (querySnapshot) {
        querySnapshot.forEach((doc) => {
          let meetData = { id: doc.id, ...doc.data() };
          setMeetsCollection([...meetData.meets]);
          // Filtering By meetName
          filterByNameAndDate(meetsCollection);
        });
      }
      setLoading(false);
    };
    fetchMeetsData();
  }, [getMeetsAgain]);



  // searching meet cards and if not exists .. setting no results found true
  const [noResultsFound, setNoResultsFound] = useState(false)
  const searchMeetCard = (e) => {
    setGetMeetsAgain(!getMeetsAgain)
    const updated = meetsCollection.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
    setNoResultsFound(updated)
    if (updated.length) {
      setNoResultsFound(false)
    } else {
      setNoResultsFound(true)
    }

  }
  return (
    <div className="mainDashboardPage">
      {matches ? <MobileNavbar /> : <DesktopSideBar />}

      <div className="dashboardPageContent">
        {/* Filter Bar for Mobile View */}
        <div className="mobileFilterBar">
          {meetTypes.map((item) => {
            return (
              <button
                id={item === typeToFilter ? "AllFilterBtn" : ""}
                onClick={() => setTypeToFilter(item)}
                key={item}
              >
                {item}
              </button>
            );
          })}
        </div>
        {/* search bar for mobile view */}
        <div className="searchBarHomePage">
          <input
            type="text"
            name="search"
            placeholder="Search"
            className="athleteSearchInp"
            onChange={searchMeetCard}
          />
        </div>
        <div className="headingBar">
          <h5>Pages / Dashboard</h5>
          <h1>Dashboard</h1>
        </div>
        {/* Filter Bar for Desktop View */}
        <div className="competitionsBar">
          <div>
            <span className="upcomingCompetitionsHeading">
              Upcoming Competitions
            </span>
          </div>
          <div className="filterBtnsDiv">
            {meetTypes.map((item) => {
              return (
                <button
                  id={item === typeToFilter ? "AllFilterBtn" : ""}
                  onClick={() => setTypeToFilter(item)}
                  key={item}
                >
                  {item}
                </button>
              );
            })}
          </div>
        </div>


        {noResultsFound && (
          <div style={{ width: '85%', backgroundColor: '#fafafa', margin: '20px auto', minHeight: '40vh' }}>
            <div className="Team1DivHeadingDiv">
              <span className="heading">No Results Found</span>
            </div>
          </div>
        )}


        <div className={!noResultsFound ? 'meetCards' : "meetCards d-none"} >
          {(loading && (
            <CircularProgress size={"70px"} className="loadingComponent" />
          )) ||
            (meetsCollection.length !== 0 &&
              meetsCollection.map((item, index) => {
                if (item.disciplines === typeToFilter) {
                  return <MeetCard meetDetailObj={item} key={index} />;
                } else if (typeToFilter === "All") {
                  return <MeetCard meetDetailObj={item} key={index} />;
                }
              }))}
        </div>

        <span className="bottomText" style={{ paddingLeft: "30px" }}>
          © 2023 IGNITE GYMNASTICS. All Rights Reserved.{" "}
        </span>
      </div>
    </div>
  );
};

export default Index;
